import vue from 'vue'
import Vuex from 'vuex';

vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        userInfo: { // 用户信息
            avatarurl: '',
            is_vip: 3,
            is_vip_end: 0,
            nickname: '未登录',
            score_balance: 0,
            uid: 0,
            vip_end_date: '未开通',
            vip_name: '普通用户',
            vip_type: 0
        },
        isLogin: false, // 是否登录
        isPayPopShow: false,
        ShowLogin: false,  // 登录弹窗
        show_vip_time: false,

        isbytg: false, // 必应推广
        istg: false, // 推广弹窗
        isvideoWin: false, // 推广视频弹窗
        isvideoWin2: false, // 本站视频弹窗
        isvideoWin3: false, // 首页精选视频弹窗
        byisvideoWin: false, // 必应推广视频弹窗
        byisvideoWin2: false, // 必应本站视频弹窗
        byisvideoWin3: false, // 必应首页精选视频弹窗
        isvideoWin3data: {
            preview: '',
            url: '',
        }, // 首页精选视频弹窗
        show_userinfo_compoments: false,//个人资料弹框
        realName: false,//实名认证
        show_bindphone_compoments: false,
        show_bindwechat_compoments: false,
        upYouDetail: {//升级永久会员信息
            upgrade_good: {
                coupon_money: 0
            }
        },
        baoDian: false, // 响应宝典
        ShowTools: false, // 工具箱模板是否
        Navigation: { // 工具箱导航模板
            all_template_list: [], // 全部工具
            default_template_list: [], // 右侧默认
            hot_template_list: [], // 热门工具
            user_template_list: [], // 用户右侧工具
        },
        fisYouh: false,//挽留1
        secYouh: false,//挽留2
        header_r_show: 1,
        vip_youhui_header_show: false,//header顶部是否显示优惠提示
        vip_congratulations_show: false,//恭喜你成为xxx会员弹框

        Technical_Show: false,//技术维护弹窗
        isAdBdLogoShow: true, // 是否显示百度下载广告logo
    },
    mutations: {
        // 响应宝典
        setBaoDian(state, boolean) {
            state.baoDian = boolean;
        },
        setUpyouDetail(state, boolean) {
            state.upYouDetail = boolean;
        },
        setUserInfo(state, data) {
            state.userInfo = data
        },
        setIsLogin(state, data) {
            state.isLogin = data;
        },
        setisPayPopShow(state, data) {
            state.isPayPopShow = data;
        },
        setShowLogin(state, boolean) {
            state.ShowLogin = boolean;
        },
        showVipTime(state, boolean) {
            state.show_vip_time = boolean;
        },
        setIstg(state, data) {
            state.istg = data;
        },
        setIsbytg(state, data) {
            state.isbytg = data;
        },
        setIsvideoWin(state, data) {
            state.isvideoWin = data;
        },
        setIsvideoWin2(state, data) {
            state.isvideoWin2 = data;
        },
        setIsvideoWin3(state, data) {
            state.isvideoWin3 = data;
        },
        setByIsvideoWin(state, data) {
            state.byisvideoWin = data;
        },
        setByIsvideoWin2(state, data) {
            state.byisvideoWin2 = data;
        },
        setByIsvideoWin3(state, data) {
            state.byisvideoWin3 = data;
        },
        setIsvideoWin3data(state, data) {
            state.isvideoWin3data = data;
        },
        setShowUserInfo(state, boolean) {
            state.show_userinfo_compoments = boolean;
        },
        setRealName(state, boolean) {
            state.realName = boolean;
        },
        setShowBindPhone(state, boolean) {
            state.show_bindphone_compoments = boolean;
        },
        setShowBindWechat(state, boolean) {
            state.show_bindwechat_compoments = boolean;
        },
        setNavigation(state, boolean) {
            state.Navigation = boolean;
        },
        setShowTools(state, boolean) {
            state.ShowTools = boolean;
        },

        /* 新版支付相关 */
        setFisYouh(state, boolean) {
            state.fisYouh = boolean;
        },
        setSecYouh(state, boolean) {
            state.secYouh = boolean;
        },
        setHeader_r_show(state, data) {
            state.header_r_show = data;
        },
        setVipYouhuiHeaderShow(state, data) {
            state.vip_youhui_header_show = data;
        },
        //恭喜你成为xxx弹窗
        setVipCongratulationsShow(state, data) {
            state.vip_congratulations_show = data;
        },
        //技术维护弹窗
        setTechnical_Show(state, data) {
            state.Technical_Show = data;
        },
        setIsAdBdLogoShow(state, boolean) {
            state.isAdBdLogoShow = boolean;
        },
    },
    actions: {},
    getters: {
        userInfo(state) {
            return state.userInfo;
        },
        isLogin(state) {
            return state.isLogin;
        },
        openLogin(state, data) {
            return state.openLogin;
        },
        ShowLogin(state, data) {
            return state.ShowLogin;
        },
        istg(state, data) {
            return state.istg;
        },
        isvideoWin(state, data) {
            return state.isvideoWin;
        },
        isvideoWin2(state, data) {
            return state.isvideoWin2;
        },
        isvideoWin3(state, data) {
            return state.isvideoWin3;
        },
        isvideoWin3data(state, data) {
            return state.isvideoWin3data;
        },
        realName(state, data) {
            return state.realName;
        },
        show_bindphone_compoments(state, data) {
            return state.show_bindphone_compoments;
        },
        show_bindwechat_compoments(state, data) {
            return state.show_bindwechat_compoments;
        },
        isNavigation(state, data) {
            return state.Navigation;
        },
        isShowTools(state, data) {
            return state.ShowTools;
        },
        isTechnical_Show(state, data) {
            return state.Technical_Show;
        },

        isAdBdLogoShow(state, data) {
            return state.isAdBdLogoShow;
        },
    }
});

export default store

